import { getSetting, setSetting, settingKeys } from './settings';
import { isValidColorTheme, COLOR_THEME_NONE } from '../helpers/colorThemes';

const THEME_CLASS = 'color-theme';
const THEME_CLASS_PREFIX = 'color-theme--';

export const getColorTheme = () => {
  const stored = getSetting(settingKeys.colorTheme);

  return isValidColorTheme(stored) ? stored : COLOR_THEME_NONE;
};

export const setColorTheme = (id) => setSetting(settingKeys.colorTheme, id);

export const applyColorTheme = (id = getColorTheme()) => {
  const { classList } = document.body;

  // Clear whatever was on there first, so switching themes can't leave two
  // accents fighting over the same page.
  classList.remove(THEME_CLASS, ...Array.from(classList).filter((name) => name.startsWith(THEME_CLASS_PREFIX)));

  if (id && id !== COLOR_THEME_NONE) classList.add(THEME_CLASS, `${THEME_CLASS_PREFIX}${id}`);
};

export const clearColorTheme = () => applyColorTheme(COLOR_THEME_NONE);

// On sign-out, so the next person on the device starts untinted
export const removeColorTheme = () => {
  setColorTheme(COLOR_THEME_NONE);
  clearColorTheme();
};

const colorTheme = {
  getColorTheme,
  setColorTheme,
  applyColorTheme,
  clearColorTheme,
  removeColorTheme,
};

export default colorTheme;
